import React from "react";
import { AlertTriangle } from "lucide-react";
import { NoteDisplay } from "src/components";

interface ReceivingDiscrepancyDefectsSectionProps {
  defects: string[];
}

const ReceivingDiscrepancyDefectsSection: React.FC<ReceivingDiscrepancyDefectsSectionProps> = ({ defects }) => {
  if (!defects.length) {
    return null;
  }

  return (
    <div className="border border-neutral-200 rounded-2xl p-5 bg-white">
      <h3 className="text-sm font-semibold text-black mb-4 tracking-wide uppercase flex items-center">
        <AlertTriangle className="w-4 h-4 mr-2" />
        Defects
      </h3>
      <div className="space-y-4">
        {defects.map((defect, index) => (
          <NoteDisplay note={{ body: defect, date: "" }} key={index} />
        ))}
      </div>
    </div>
  );
};

export { ReceivingDiscrepancyDefectsSection };
